// extracted by mini-css-extract-plugin
module.exports = {"homePage":"HomePage_homePage__2g2w7","content":"HomePage_content__Gwy5P"};